import { LayoutDashboard, Bot, Bell, UserCog } from "lucide-react";
import { cn } from "@/lib/utils";

const ITEMS = [
  { id: "overview", label: "Özet", icon: LayoutDashboard },
  { id: "bot", label: "Botlar", icon: Bot },
  { id: "notifications", label: "Bildirimler", icon: Bell },
  { id: "profile", label: "Profil", icon: UserCog },
];

export const BottomNav = ({ active, onNavigate }) => (
  <nav
    data-testid="bottom-nav"
    className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[var(--surface)]/95 backdrop-blur-xl border-t border-[var(--border)]"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <div className="grid grid-cols-4">
      {ITEMS.map((item) => {
        const Icon = item.icon;
        const isActive = active === item.id;
        return (
          <button
            key={item.id}
            data-testid={`bottomnav-${item.id}`}
            onClick={() => onNavigate(item.id)}
            className={cn(
              "flex flex-col items-center justify-center gap-1 h-16 min-w-[44px] transition-colors",
              isActive ? "text-[var(--pos)]" : "text-[var(--text-faint)]"
            )}
          >
            <Icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.4 : 1.8} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
    </div>
  </nav>
);
